import baseStyles from '../Base/Base.styles'
import baseSvgStyles from '../BaseSvg/BaseSvg.styles'
import merge from 'lodash/merge'

export default properties => {
  const { 
    base, 
    layout,
    featureBackgroundColor,
    quoteBackgroundColor,
    featureBorderColor,
    quoteBorderColor,
    quoteSvg
  } = properties

  let jss = {
    root: {
      ...baseStyles(base),
      ...baseSvgStyles(quoteSvg),
      '--feature-bg-color': featureBackgroundColor,
      '--feature-border-color': featureBorderColor,
      '--quote-bg-color': quoteBackgroundColor,
      '--quote-border-color': quoteBorderColor,
      '& .testimonial-feature': {
        display: 'grid',
        gridAutoFlow: 'dense'
      }
    }
  }

  if( layout == 'content-left') {
    jss = merge(jss, {
      root: {
        '& .testimonial-feature': {
          gridTemplateColumns: '1.5fr 1fr',
        },
        '& .testimonial-feature .feature-bg': { 
          gridColumn: 1,
          marginRight: '-40px'
         },
        '& .testimonial-feature .quote-bg': { 
          gridColumn: 2,
          padding: '40px 40px 40px 80px'
        },
        '& .testimonial-feature .quote-icon': { 
          top: '20px',
          left: '60px'
        }
      } 
    })
  }

  if( layout == 'content-right') {
    jss = merge(jss, {
      root: {
        '& .testimonial-feature': {
          gridTemplateColumns: '1fr 1.5fr',
        },
        '& .testimonial-feature .feature-bg': { 
          gridColumn: 2,
          marginLeft: '-40px'
         },
        '& .testimonial-feature .quote-bg': { 
          gridColumn: 1,
          padding: '40px 80px 40px 40px'
        },
        '& .testimonial-feature .quote-icon': { 
          top: '20px',
          left: '20px'
        }
      } 
    })
  }

  return jss
}
